import React, { useState } from 'react';
import './ContactPage.css';
import Layout from '../../components/layout/Layout';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Basic validation
    if (
      !formData.name ||
      !formData.email ||
      !formData.subject ||
      !formData.message
    ) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    // Simulate form submission
    setSubmitted(true);
  };

  return (
    <Layout>
      <div className="contact-page-container">
        <h2 className="contact-page-title">Fale Conosco</h2>
        <p className="contact-page-description">
          Estamos aqui para ajudar! Se você tiver alguma dúvida, sugestão ou
          problema, entre em contato conosco utilizando o formulário abaixo.
          Responderemos o mais rápido possível.
        </p>

        <div className="contact-form-container">
          {submitted ? (
            <div className="success-message">
              <p>
                Sua mensagem foi enviada com sucesso! Entraremos em contato em
                breve.
              </p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              {error && <div className="error-message">{error}</div>}
              <div className="input-group">
                <label htmlFor="name">Nome:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Digite seu nome"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>

              <div className="input-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Digite seu email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              <div className="input-group">
                <label htmlFor="subject">Assunto:</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="Assunto do seu contato"
                  value={formData.subject}
                  onChange={handleInputChange}
                />
              </div>

              <div className="input-group">
                <label htmlFor="message">Mensagem:</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Digite sua mensagem"
                  value={formData.message}
                  onChange={handleInputChange}
                ></textarea>
              </div>

              <button type="submit" className="contact-submit-button">
                Enviar Mensagem
              </button>
            </form>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;
